import React from 'react';
import './MembersSelectSkeleton.css';

/**
 * Skeleton loader for members select dropdown
 */
const MembersSelectSkeleton = () => {
  return (
    <div className="members-select-skeleton">
      <div className="skeleton-select-input" />
      <div className="skeleton-members-list">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="skeleton-member-item" />
        ))}
      </div>
    </div>
  );
};

export default MembersSelectSkeleton;
